import React from 'react';

import './Atlas.css';

interface Props {
    worldName: string;
    desc: string;
}
interface State {
    hover?: boolean;
}

export class AtlasCard extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    public render() {
        return <div>
            <div className="atlas-card">
                <div onMouseEnter={() => this.setState({ hover: true })}
                    onMouseLeave={() => this.setState({ hover: false })}
                >
                    <img className="atlas-map" alt="map"
                        src={`https://worldspinner-atlas.s3.amazonaws.com/worlds/${this.props.worldName}.jpg`}
                        width="100%" />
                    <div className="atlas-overlay"
                        style={{ display: this.state.hover ? "block" : "none" }}
                        dangerouslySetInnerHTML={{ __html: this.props.desc }} >
                    </div>
                </div>
                <div className="atlas-under">
                    <a download className="atlas-download"
                        href={`https://worldspinner-atlas.s3.amazonaws.com/worlds/${this.props.worldName}.zip`}>
                        <div className="atlas-download"> download <img src={require("./download.png")} width="15px" alt="download button" /> </div>
                    </a>
                    {this.props.worldName}
                </div>

            </div>

        </div>
    }

}
